<rid-spacer class="stack-cell" [class.hidden]="compressed()">
  <rid-syllabic-text-input class="min-w-16" variant="STOM">
    <div class="flex place-self-center">
      <rid-vertical-spacer>
        <rid-klank-card klank="x" />
      </rid-vertical-spacer>

      <rid-algorithm-card [showDubbelzetter]="voet().hasDubbelzetter && voet().content.length === 0" />
    </div>
  </rid-syllabic-text-input>
</rid-spacer>

@let _mode = mode();
@if (_mode === 'AS_INPUT') {
  @let numberOfSlots = voet().length;
  @let emptySlots = numberOfSlots - voet().content.length;

  <rid-syllabic-text-input
    class="stack-cell"
    [class.min-w-16]="!compressed()"
    variant="NORMAAL"
    [compressed]="compressed()"
    animate.enter="wait-1000 anim-pop-in"
    ridSfx="BUBBLE_POP"
  >
    <div class="flex place-self-center">
      <rid-vertical-spacer>
        <rid-compressable-klank-card content="x" />
      </rid-vertical-spacer>

      <!-- actual content -->
      @for (k of voet().content.slice(0, voet().length - 1); track $index) {
        <rid-syllabic-card #syllabicCard [value]="k" animate.enter="anim-pop-in" />
      }
      @for (i of Array.from({ length: emptySlots - 1 }); track $index) {
        <rid-algorithm-card [showDubbelzetter]="$index === 0 && voet().hasDubbelzetter && voet().content.length === 0" />
      }
      @if (numberOfSlots > 1 && !compressed()) {
        <div class="mx-4 -my-4 border-l-4 border-dashed border-emerald-500"></div>
      }
      <!-- last klank: either filled or still empty -->
      @for (k of voet().content.slice(voet().length - 1); track $index) {
        <rid-syllabic-card #syllabicCard lpWizardTarget="last-klank" [value]="k" animate.enter="anim-pop-in" />
      }
      @for (i of emptySlots > 0 ? [0] : []; track $index) {
        <rid-algorithm-card
          lpWizardTarget="last-klank"
          [showDubbelzetter]="voet().length === 1 && voet().hasDubbelzetter && voet().content.length === 0"
        />
      }
    </div>
  </rid-syllabic-text-input>
} @else {
  <i-klankvoet-normal
    class="stack-cell size-24 text-emerald-500"
    [showDubblezetter]="voet().hasDubbelzetter"
    animate.enter="anim-pop-in"
    animate.leave="wait-250 anim-pop-out"
    ridSfx="BUBBLE_POP"
  />
}
